<template>
	<div grey-back full-height>

        <v-toolbar flat fixed>
          <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
          <v-toolbar-title class="white--text">Developer Options</v-toolbar-title>
        </v-toolbar>

       <div class="hasToolbar">

            <v-list margin-top-ten nopadding>
                <v-subheader>For developement only</v-subheader>
                <v-divider></v-divider>
                <v-list-tile @click="fn_copyDbFile">

                  <v-list-tile-content>
                    <v-list-tile-title>Copy DB</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile to="/settings/token">

                  <v-list-tile-content>
                    <v-list-tile-title>Copy Token</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile @click="fn_functionTest">
                  <v-list-tile-content>
                    <v-list-tile-title>Test Function</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile to="/settings/instasync" v-ripple>
                  <v-list-tile-content>
                      <v-list-tile-title>Insta Sync Status</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile to="/settings/documentsync" v-ripple>
                  <v-list-tile-content>
                      <v-list-tile-title>Documents Insta Sync Status</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile to="/settings/connections" v-ripple>
                  <v-list-tile-content>
                      <v-list-tile-title>Connections/Phone Numbers</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile to="/settings/join" v-ripple>
                  <v-list-tile-content>
                      <v-list-tile-title>Join With Connection ID</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile to="/settings/tempview" v-ripple>
                  <v-list-tile-content>
                      <v-list-tile-title>Taxable Value Transactions</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile to="/settings/apitest" v-ripple>
                  <v-list-tile-content>
                      <v-list-tile-title>API Test</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile @click="fn_revokeAccount" v-ripple>
                  <v-list-tile-content>
                      <v-list-tile-title>Revoke Account</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile @click="fn_signOutAccount" v-ripple>
                  <v-list-tile-content>
                      <v-list-tile-title>Sign Out from Google Account</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile @click="fn_openBarcodeScanner" v-ripple>
                  <v-list-tile-content>
                      <v-list-tile-title>Scan Barcode</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile @click="fn_setBackupTime" v-ripple>
                  <v-list-tile-content>
                      <v-list-tile-title>Set Backup Time</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

            </v-list>

            <v-btn color="primary" @click="$root.fn_sendPushNotification">Send Push Notification</v-btn>

        </div>
    </div>
</template>

<script>
    export default{
        methods:{
          fn_openBarcodeScanner: function(){
            this.$router.push('/barcode/scanner');
                // let postObj = {'url':'https://bizopsstaging-barcode-scanner.web.app/'}
                // this.postData('ScanBarcode', postObj, 
                // {
                //       onSuccess: function(response){
                //           console.log(response);
                //       }, 
                //       onError: function(error){
                //           console.log(error);
                //       }
                // });
            },

            fn_copyDbFile: function(){
                let self = this;
                this.getData('CopyDbFile', this.$root.CurrentBusiness.BusinessID, 
                {
                      onSuccess: function(response){
                          console.log(response);
                      }, 
                      onError: function(error){
                          console.log(error);
                      }
                });
            },

            fn_functionTest: function(){
                let postData = require('../../default_data.js').data.defaultDataJson
                // let postData = {"masterDataJson":{"businessList":[{"BusinessID":"c59facdd-352f-476f-8666-f9b307311876","BusinessName":"Xyz Ltd","AdminName":null,"BusinessProfileNumber":null,"Address":null,"Email":null,"StateID":"913236d6-8d5d-4473-afb1-efac40c94073","State":"Delhi","GSTRegistrationStatus":1,"GSTNumber":"12ABCDE1234A9Z9","GSTRegistrationDate":null,"HSNApplicable":true,"DataDrive":"bizopstest4@gmail.com","TaxMode":1,"CreatedOn":"2023-03-30T13:06:47.53","CreatedBy":null,"ModifiedOn":"2023-03-30T13:06:47.53","ModifiedBy":null,"Status":1,"OpeningDateValue":"2023-03-01T00:00:00","OpeningDate":"2023-03-01T00:00:00.000","DeactiveOn":null,"UpiID":null,"UPIName":null,"UserName":"Test owner","IsSupport":false,"IsRemote":false,"ClonedBusinessID":null,"IsAccountantOnly":false,"UserType":1,"IsDataOwner":true},{"BusinessID":"a275af57-25cd-4502-8962-d7d177ad4f27","BusinessName":"Abc Corp","AdminName":null,"BusinessProfileNumber":null,"Address":null,"Email":null,"StateID":"913236d6-8d5d-4473-afb1-efac40c94073","State":"Delhi","GSTRegistrationStatus":1,"GSTNumber":"12ABCDE1234A9Z9","GSTRegistrationDate":null,"HSNApplicable":true,"DataDrive":"bizopstest4@gmail.com","TaxMode":1,"CreatedOn":"2023-03-28T01:28:15.893","CreatedBy":null,"ModifiedOn":"2023-03-28T01:28:15.893","ModifiedBy":null,"Status":1,"OpeningDateValue":"2023-03-01T00:00:00","OpeningDate":"2023-03-01T00:00:00.000","DeactiveOn":null,"UpiID":null,"UPIName":null,"UserName":"Test owner","IsSupport":false,"IsRemote":false,"ClonedBusinessID":null,"IsAccountantOnly":false,"UserType":1,"IsDataOwner":true}]}};
                this.postData('FunctionTest', postData, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                });
            },

            fn_setBackupTime: function(){
                let self = this;
                let dateNow = new Date();
                dateNow.setDate(dateNow.getDate() - 3);
                let formatDate = dateNow.toISOString();
                let dataObj = {"autoBackupTime":formatDate}
                this.postFilterData('BackupTime', this.$root.CurrentBusiness.BusinessID, dataObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.fn_updateBackupTime(formatDate);
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_updateBackupTime: function(formatDate){
                let dataObj = {"autoBackupTime":formatDate}
                this.postFilterData('UpdateBackupTime', this.$root.CurrentBusiness.BusinessID, dataObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_revokeAccount: function(){
              AndroidRoutingTest.revokeAccount();
            },

            fn_signOutAccount: function(){
              this.getData('SignOutAccount', null, 
                {
                      onSuccess: function(response){
                          console.log(response);
                      }, 
                      onError: function(error){
                          console.log(error);
                      }
                });
            },

            fn_goBack: function(){
                this.$router.go(-1);
            },
        },
        mounted: function(){
            window.js_globals.fn_onBackPress = this.fn_goBack;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/settings/developer_options.vue